import { Card, Dropdown, Modal } from "antd";
import { EllipsisOutlined, LoginOutlined } from "@ant-design/icons";
import { useState } from "react";
import ModalTable from "./list/ModalTable";
import PropTypes from "prop-types";
import { useDashboard } from "../../../app/hooks/useDashboard";

const TotalPresent = (props) => {
  TotalPresent.propTypes = {
    count: PropTypes.array.isRequired,
  };

  const { count: totalPresent } = props;
  const [isCoreModalVisible, setIsCoreModalVisible] = useState(false);
  const [isProjectBasedModalVisible, setIsProjectBasedModalVisible] =
    useState(false);
  const [presentData, setPresentData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { getTotalPresent } = useDashboard();

  const showCoreModal = async () => {
    setLoading(true);
    try {
      const data = await getTotalPresent({ employeeType: "core" });
      setPresentData(data);
      setIsCoreModalVisible(true);
    } catch (error) {
      console.error("Failed to fetch absent data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setIsCoreModalVisible(false);
    setIsProjectBasedModalVisible(false);
  };

  const showProjectBasedModal = async () => {
    setLoading(true);
    try {
      const data = await getTotalPresent({ employeeType: "contractual" });
      setPresentData(data);
      setIsProjectBasedModalVisible(true);
    } catch (error) {
      console.error("Failed to fetch absent data:", error);
    } finally {
      setLoading(false);
    }
  };

  const items = [
    {
      label: <p onClick={showCoreModal}>CORE</p>,
    },
    {
      type: "divider",
    },
    {
      label: <p onClick={showProjectBasedModal}>PROJECT BASED</p>,
    },
  ];

  return (
    <Card className="summary-count-card">
      <Dropdown menu={{ items }} className="dropdown-btn" trigger={["click"]}>
        <button className="modal-btn">
          <EllipsisOutlined className="dropdownIcon" />
        </button>
      </Dropdown>
      <Modal
        open={isCoreModalVisible}
        onCancel={handleCancel}
        footer={null}
        width={1000}
        destroyOnClose
      >
        <h3 className="summary-modal-title">Core</h3>
        <ModalTable data={presentData} loading={loading} />
      </Modal>
      <Modal
        open={isProjectBasedModalVisible}
        onCancel={handleCancel}
        footer={null}
        width={1000}
        destroyOnClose
      >
        <h3 className="summary-modal-title">Project Based</h3>
        <ModalTable data={presentData} loading={loading} />
      </Modal>

      <div className="summary-count-card">
        {/* temporary */}
        <LoginOutlined style={{ fontSize: "50px", margin: "20px" }} />
        <div>
          <h1 className="cardNum">{totalPresent}</h1>
          <p className="cardDes">Total Present</p>
        </div>
      </div>
    </Card>
  );
};

export default TotalPresent;
